class MetaTagsStore {
    constructor() {
        this.store = new Map();
        this.mergedMetatags = { tags: {} };
        this.subscribers = new Set();
    }
    registerInstance(instanceId, instanceTs) {
        if (!this.store.has(instanceId)) {
            this.store.set(instanceId, {
                instanceTs: instanceTs,
            });
        }
        return () => {
            this.store.delete(instanceId);
            this.saveAndEmit();
        };
    }
    setInstanceMetaTags(instanceId, metaTags) {
        const oldInstance = this.store.get(instanceId);
        if (oldInstance) {
            this.store.set(instanceId, Object.assign(Object.assign({}, oldInstance), { metaTagsModel: metaTags }));
            this.saveAndEmit();
        }
    }
    clear() {
        this.store.clear();
        this.saveAndEmit();
    }
    getState() {
        return this.mergedMetatags;
    }
    subscribe(listener) {
        this.subscribers.add(listener);
        return () => {
            this.subscribers.delete(listener);
        };
    }
    saveAndEmit() {
        this.mergedMetatags = this.mergeStoreInstances();
        this.subscribers.forEach((listener) => listener(this.mergedMetatags));
    }
    mergeStoreInstances() {
        return Array.from(this.store.values())
            .filter((metaTagInstance) => !!metaTagInstance.metaTagsModel)
            .sort((a, b) => a.instanceTs - b.instanceTs)
            .reduce((acc, { metaTagsModel }) => {
            var _a, _b;
            return ({
                title: (_a = metaTagsModel.title) !== null && _a !== void 0 ? _a : acc.title,
                lang: (_b = metaTagsModel.lang) !== null && _b !== void 0 ? _b : acc.lang,
                tags: Object.assign(Object.assign({}, acc.tags), metaTagsModel.tags),
            });
        }, { tags: {} });
    }
}
export const metaTagsStore = new MetaTagsStore();
